import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import { useState, useEffect, useRef } from 'react';
import Utils from '../../../../utils';
import apiClient from '../data';
/** @type {import('./types').UseJobResult} */

var DEFAULT_VALUE = {
  loading: true,
  error: '',
  job: null
};
/**
 * @param {string} workspace
 * @param {string} jobId
 * @returns {import('./types').UseJobResult & {setJob: (job: import('../data/types').JobSummary) => any}}
 */

var useJob = function useJob(jobId, workspace) {
  var _useState = useState(DEFAULT_VALUE),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var poolingJobTimeout = useRef(null);

  var update = function update(loading, error, job) {
    setState({
      loading: loading,
      error: error,
      job: job
    });
  };

  useEffect(function () {
    return function () {
      // cleanup last timer when component unmount
      if (poolingJobTimeout.current) clearTimeout(poolingJobTimeout.current);
    };
  }, []);
  useEffect(function () {
    if (!jobId) return update(false, '', null);
    apiClient.getJobById(jobId, workspace).then(function (job) {
      return update(false, '', job);
    }, function (error) {
      return update(false, Utils.getPrettyError(error), null);
    });
  }, [workspace, jobId]);
  /** @param {import('../data/types').JobSummary} job */

  var setJob = function setJob(job) {
    update(false, '', job);
  };

  return _objectSpread({}, state, {
    setJob: setJob
  });
};

export default useJob;